import { Button, Flex, InfoBox } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

export type GenerationErrorStateProps = {
  message: string;
  onRetry: () => void;
};

// A failed run terminates as a whole and offers Retry, which reopens the modal.
export const GenerationErrorState = ({ message, onRetry }: GenerationErrorStateProps) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap={SPACING.MEDIUM}
      className={styles.errorState}
      data-testid="ddq-generate-draft-failed"
    >
      <InfoBox variant="error" title={message} />
      <Button onClick={onRetry} data-testid="ddq-generate-draft-retry">
        Retry
      </Button>
    </Flex>
  );
};
